import { useNavigate } from "react-router";

const ApplyForm = () => {
  const navigate = useNavigate();
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Apply Loan</h4>
          </div>
        </div>
        <div className="card" style={{ minHeight: "70vh" }}>
          <div
            className="d-flex  justify-content-center align-items-center"
            style={{ minHeight: "70vh", gap: "20px", flexDirection: "column" }}
          >
            <button
              className="btn btn-primary"
              onClick={() => navigate("/customer-creation-with-aadhar")}
            >
              Add Loan With Aadhar Card
            </button>
            <button
              className="btn btn-primary"
              onClick={() => navigate("/customer-creations")}
            >
              Add Loan Without Aadhar Card
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplyForm;
